// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kr-0";
export var fileList = "_kr-2";
export var removeFileButton = "_kr-1";